import React, { DragEvent } from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function DropZone(props: Props) {
  const ref = React.useRef<HTMLDivElement>(null);
  const dropZone = ref.current;
  const [state, setState] = React.useState({
    isDraggingOver: false,
  });

  React.useEffect(() => {
    const dragOver = (e: DragEvent | any) => {
      e.preventDefault();

      setState((state) => ({ ...state, isDraggingOver: true }));
    };
    const dragLeave = () =>
      setState((state) => ({ ...state, isDraggingOver: false }));

    const drop = (e: DragEvent | any) => {
      e.preventDefault();

      const files = e.dataTransfer ? e.dataTransfer.files : [];

      setState((state) => ({ ...state, isDraggingOver: false }));
      !!files[0] &&
        props.drop({
          name: files[0].name,
          size: files[0].size,
          type: files[0].type,
          uri: URL.createObjectURL(files[0]),
        });
    };

    if (dropZone) {
      dropZone.addEventListener("dragover", dragOver);
      dropZone.addEventListener("dragleave", dragLeave);
      dropZone.addEventListener("drop", drop);
    }

    return () => {
      if (dropZone) {
        dropZone.removeEventListener("dragover", dragOver);
        dropZone.removeEventListener("dragleave", dragLeave);
        dropZone.removeEventListener("drop", drop);
      }
    };
  }, [dropZone, props.drop, setState]);

  return (
    <div ref={ref} className={classNames(styles.dropZone, props.className)}>
      {props.children(state)}
    </div>
  );
}

export { DropZone };
